import { useEffect, useState } from "react";
import api, { fmtMXN, daysFromNow } from "../lib/api";
import Topbar from "../components/Topbar";
import KpiCard from "../components/KpiCard";
import { Wallet, CreditCard, AlertTriangle, CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TreasuryDashboard() {
  const [invoices, setInvoices] = useState([]);
  const [payments, setPayments] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    api.get("/invoices").then((r) => setInvoices(r.data)).catch(() => {});
    api.get("/payments").then((r) => setPayments(r.data)).catch(() => {});
  }, []);

  const toPay = invoices.filter((i) => i.status === "validated" || i.status === "scheduled_for_payment");
  const overdue = toPay.filter((i) => {
    const d = daysFromNow(i.due_date);
    return d !== null && d < 0;
  }).length;
  const soon = toPay.filter((i) => {
    const d = daysFromNow(i.due_date);
    return d !== null && d >= 0 && d <= 3;
  }).length;
  const totalDue = toPay.reduce((a, b) => a + b.total, 0);
  const paidThisMonth = payments
    .filter((p) => new Date(p.payment_date).getMonth() === new Date().getMonth())
    .reduce((a, b) => a + b.amount, 0);

  return (
    <>
      <Topbar title={t("dashboard.treasury")} subtitle={t("dashboard.treasurySubtitle")} />
      <div className="p-6 space-y-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <KpiCard testId="kpi-tres-overdue" label={t("dashboard.kpis.tresOverdue")} value={overdue} icon={AlertTriangle} accent={overdue > 0} />
          <KpiCard testId="kpi-tres-soon" label={t("dashboard.kpis.tresSoon")} value={soon} icon={AlertTriangle} />
          <KpiCard testId="kpi-tres-todue" label={t("dashboard.kpis.tresToDue")} value={fmtMXN(totalDue)} icon={Wallet} />
          <KpiCard testId="kpi-tres-paid" label={t("dashboard.kpis.tresPaid")} value={fmtMXN(paidThisMonth)} icon={CheckCircle2} />
        </div>

        <button
          data-testid="tres-go-payments-btn"
          onClick={() => navigate("/pagos")}
          className="w-full bg-gradient-to-r from-[#1A1A1A] to-[#2D2D2D] text-white rounded-2xl p-6 flex items-center justify-between hover:brightness-110 transition"
        >
          <div className="text-left">
            <div className="font-display font-extrabold text-2xl">{t("dashboard.goToPayments")}</div>
            <div className="text-sm opacity-80 mt-0.5">{t("dashboard.goToPaymentsSub")}</div>
          </div>
          <div className="w-14 h-14 rounded-2xl bg-[#FFDF00] flex items-center justify-center">
            <CreditCard className="w-7 h-7 text-[#1A1A1A]" strokeWidth={2.5} />
          </div>
        </button>
      </div>
    </>
  );
}
